// extracted by mini-css-extract-plugin
module.exports = {"container":"keyitems_container__3yxKF","info":"keyitems_info__3BSy4","wrap":"keyitems_wrap__11mz7","icon":"keyitems_icon__21Bab"};